<navbar class="nav-bar"></navbar>
<button class="to-the-top" *ngIf="showScrollButton" (click)="scrollToTheTop()" _ngcontent-cpu-c78="" title="לראש העמוד">
    <mat-icon class="arrow">keyboard_arrow_up</mat-icon></button>
<router-outlet></router-outlet>
<footer *ngIf="showAdv&&(46375==userId)">
    <!-- <footer *ngIf="showAdv"> -->
    <div class="adv">
        <span class="close" (click)="closeAdv()">X</span>
        <a target="_blank" (click)="addClick()" [href]="adv.link">
            <img [src]="'../assets/images/advs/'+adv.num+'/80_850.'+adv.type" alt="advertisement" id="adv-img" />
            <!-- <iframe frameBorder="0" src="/assets/images/advs/9/ezer_mezion850x80.html" width="100%"
                height="600px"></iframe> -->
        <!-- <span style="position: absolute; top: 0; left: 0; width:100%; height: 100%; z-index: 1;"></span> -->

        </a>

    </div>
</footer>

<!-- <verify-code-modal *ngIf="showMessege" (closeWindow)="closeMessege()"></verify-code-modal> -->
<!-- <verify-code-modal *ngIf="showMessege" (closeWindow)="closeMessege()"></verify-code-modal> -->